import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Sends signup data to Django backend /signup/ endpoint
 * @param {Object} signupData - The registration data from the React form
 * @returns {Promise} Axios response promise
 */
export async function signupOwner(signupData) {
    const response = await axios.post(`${API_URL}/owner/signup/`, signupData, {
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
}